/** Default `continue*` acknowledgement flags for the patient initiation wizard. */
export const REGISTER_PATIENT_INITIAL_STATE = {
  confirmation_risk_patient: false,
  confirmation_risk_prescriber: false,
  continueOffLabel: false,
  continueIndicationIncomplete: false,
  continueWithoutConfirmation: false,
  continueWithPregnancyTestDateOutdated: false,
  continueWithPregnancyTestDateIncomplete: false,
  continueMaximumNumberOfCyclesExceeded: false,
  continueMaximumNumberOfWeeksExceeded: false,
  continueMaximumNumberOfWeeksExceededAgain: false,
  continueMaximumNumberOfCapsulesExceeded: false,
  nonComplaintValidationPassed: false,
  continueWithDateOfBirthUnderEighteen: false,
  continueCapsulePerCycleIncomplete: false,
  continueCapsulePerWeekIncomplete: false,
  continueNumberOfCyclesIncomplete: false,
  continueNumberOfWeeksIncomplete: false,
};
